<template>
  <QDialog v-model="showDialog">
    <QCard class="lease-inclusion-dialog full-width q-pa-md" style="max-width: 1097px">
      <QCardSection class="column items-center q-pa-none q-ma-none full-width scroll">
        <QCardSection class="column q-pa-none q-mb-lg full-width">
          <QBtn
            rounded
            class="calculator-dialog-close q-mb-md"
            flat
            :icon-right="closeIconCircle"
            size="16px"
            color="primary"
            align="left"
            @click="handleClose"
          >
            Close
          </QBtn>
        </QCardSection>
        <QCardSection class="column q-pa-none q-mb-lg full-width" style="max-width: 870px">
          <p class="text-primary font-nunito text-weight-bold q-pa-none q-ma-none lease-inclusion-title">Lease inclusions</p>
        </QCardSection>
        <QCardSection class="lease-inclusion-content q-pa-none" style="max-width: 870px; width: 100%">
          <QCard
            bordered
            class="lease-inclusion-card row items-center q-pa-sm"
            v-for="(leaseInclusion, index) in leaseInclusionIconsModal"
            :key="`leaseInclusion_${index}`"
          >
            <div class="lease-inclusion-icon q-mr-md">
              <MainIcon :icon="leaseInclusion.icon" :size="'small'" />
            </div>
            <div class="row" style="justify-content: space-between; align-items: center; width: calc(100% - 49px)">
              <p class="lease-inclusion-label text-grey-8 font-nunito q-ma-none q-pa-none">{{ leaseInclusion.label }}</p>
              <QIcon :name="leaseInclusion.isIncluded ? checkIcon : closeIcon" color="secondary" />
            </div>
          </QCard>

          <QCardSection class="lease-inclusion-footer column full-width" style="max-width: 870px">
            <p class="font-nunito text-grey-8" style="font-size: 15px">Lease inclusions available for all makes and models.</p>
          </QCardSection>
        </QCardSection>
      </QCardSection>
    </QCard>
  </QDialog>
</template>

<script>
import { QDialog, QCard, QCardSection, QBtn, QImg, QIcon } from 'quasar';
import { evaCloseCircleOutline, evaCheckmark, evaClose } from '@quasar/extras/eva-icons';
import { LeaseInclusionIdentifierMixin } from '../../../mixins/calculator';
import MainIcon from '../Icon/Inclusion/MainIcon.vue';
export default {
  name: 'LeaseInclusionModal',
  mixins: [LeaseInclusionIdentifierMixin],
  props: {
    value: {
      type: Boolean,
      default: false
    },
    iconProps: {
      type: Object,
      default: () => ({
        size: 'small'
      })
    }
  },
  data() {
    return {
      showDialog: this.value
    };
  },
  methods: {
    handleClose: async function () {
      this.showDialog = false;
    }
  },
  created() {
    this.closeIconCircle = evaCloseCircleOutline;
    this.checkIcon = evaCheckmark;
    this.closeIcon = evaClose;
  },
  watch: {
    value(newValue) {
      this.showDialog = newValue;
    },
    showDialog(value) {
      this.$emit('input', value);
    }
  },
  components: {
    QDialog,
    QCard,
    QCardSection,
    QBtn,
    QIcon,
    MainIcon
  }
};
</script>

<style lang="sass">
.lease-inclusion-dialog
  .lease-inclusion-container
    justify-content: center
  .lease-inclusion-icon
      width: 34px
      height: 24px
  .lease-inclusion-label
    font-weight: 600
    text-wrap: pretty;

  .lease-inclusion-title
    font-size: 24px
    align-self: left
    justify-self: left

  .lease-inclusion-content
    display: flex
    flex-flow: row wrap
    gap: 8px
  .lease-inclusion-footer
    padding: 0
    margin-top: 15px
    margin-bottom: 25px

  .lease-inclusion-card
    width: calc(50% - 4px)

  .calculator-dialog-close.q-btn
    text-transform: capitalize;
    align-self: end
    .q-btn__wrapper
      padding: 0 20px
      .q-btn__content .q-icon
        margin-left: 8px
  @media (max-width:768px)
    .lease-inclusion-card
      width: 100%
    .calculator-dialog-close.q-btn .q-btn__wrapper
      padding: 0

  @media (max-width: 430px)
    .lease-inclusion-label
      max-width: 250px

  @media (max-width: 384px)
    .lease-inclusion-label
      max-width: 145px

    .lease-inclusion-footer
      margin-bottom: 0
</style>
